<style scoped>
  .pricingParams .ivu-form-item{ margin-bottom: 5px }
  .spaceBetween {justify-content: space-between}
  .initStyle .ivu-checkbox-wrapper {
    display: inline-block;
  }
</style>
<template>
  <div>
    <Form ref="pricingParams" :model="pricingParams" :label-width="80" label-position="left" class="pricingParams">
      <FormItem :label="$t('common.priceType') + '：'" prop="priceType">
        <RadioGroup v-model="pricingParams.priceType">
          <Radio :label="1">{{ $t('common.priceType0') }}</Radio>
          <Radio :label="2">{{ $t('common.priceType1') }}</Radio>
          <Radio :label="3">{{ $t('common.subCostWay1') }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('common.weightType') + '：'" prop="weightType">
        <RadioGroup v-model="pricingParams.weightType">
          <Radio :label="1">{{ $t('common.weightType0') }}</Radio>
          <Radio :label="2">{{ $t('common.weightType1') }}</Radio>
          <Radio :label="3">{{ $t('common.weightType2') }}</Radio>
        </RadioGroup>
        <div style="display: inline-block;" v-if="pricingParams.weightType === 2 || pricingParams.weightType === 3">
          ( {{ $t('common.volumeWeight') + ':' }} <InputNumber :min="0" style="width: 100px;" v-model="pricingParams.volumeWeight"></InputNumber> )
        </div>
      </FormItem>
    </Form>
      <div style="border:1px solid lightgray;width:100%;height:270px;position:relative;">
        <Form :model="pricingParams">
          <Row>
            <Col span="17" style="margin-top: -6px;">
              <Form-item>
                <Button-group size="small">
                  <Button v-for="d in OzuList" :key="d.zoneCode" :type="d.checked ? 'info' : 'default'" @click="checkOzuTypeFn(d.zoneCode)">
                    {{d.zoneCnName}}
                  </Button>
                </Button-group>
              </Form-item>
            </Col>
            <Col span="6">
              <Form-item>
                <Select v-model="pricingParams.countryId" filterable @on-change="selectCountryFn" @on-query-change="queryChange" size="small" :placeholder="$t('logisticsProvider.supportSearch')" clearable>
                  <Option v-for="(item, index) in countryNameList" :value="item.countryId" :key="index">{{item.cnName}}({{item.twoCode}}-{{item.enName}})</Option>
                </Select>
              </Form-item>
            </Col>
          </Row>
          <div style="border-bottom:1px solid lightgray;width:100%; height:150px;position:absolute;top:30px;padding:5px;overflow:auto;" class="initStyle">
            <Form-item>
              <div>
                <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">{{$t('logisticsProvider.selectAll')}}</Checkbox>
              </div>
              <CheckboxGroup v-model="pricingParams.checkCountry" @on-change="checkAllGroupChange">
                <Checkbox :label="d.countryId" v-for='(d, index) in queryCountryType' :key='index' :disabled="checkdisplayAble(d.countryId)" v-if="refreshStatus">{{d.cnName}}</Checkbox>
              </CheckboxGroup>
            </Form-item>
          </div>
          <div style="width:100%; height:80px;position:absolute;bottom:0px;padding:5px;overflow:auto;">
            <span>{{$t('logisticsProvider.hasCountry')}}：{{getStateName(pricingParams.checkCountry)}}</span>
            <a style="float:right;margin-top:50px;" @click="clearSelected">{{$t('logisticsProvider.clear')}}</a>
          </div>
        </Form>
      </div>
    <div class="normalTop flexBox spaceBetween">
      <div class="pricingFormula">
        <span>
          {{
            pricingParams.priceType === 1
              ? $t('common.tableDes0') :
                pricingParams.priceType === 2
              ? $t('common.tableDes1') :
                pricingParams.priceType === 3
              ? $t('common.tableDes2') : ''
          }}
        </span>
      </div>
      <div class="pricingButtons">
        <Button @click="addSubArea" type="primary" size="small">{{$t('logisticsProvider.addWeightArea')}}</Button>
      </div>
    </div>
    <div class="normalTop">
      <dTable highlight-row disabled-hover border stripe :columns="pricingModelColumns" :data="cachePricingData" size="small"></dTable>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
export default {
  mixins: [ Mixin ],
  props: {
    shippingMethodId: [Number, String],
    shipId: {
      default: null // 渠道ID
    },
    isAddOrEdit: {
      default: null
    },
    priceModelId: {
      default: null
    },
    priceModelZoneId: {
      default: null
    },
    curSingleDtl: {
      default: null
    },
    clickIndex: {
      default: null
    },
    getArriveCountryList: {
      default: null
    }
  },
  data () {
    var self = this;
    return {
      refreshStatus: true,
      displayAble: false,
      uploadLoading: false, // 开始上传加载
      transfer: false,
      receiveCountryList: [], // 已经选择的所有通达国家ID
      isAdd: false,
      pricingParams: {
        priceType: 1, // 计费方式
        weightType: 1, // 计重方式
        volumeWeight: 0, // 材积重
        shippingMethodId: null, // 渠道ID
        zoneCode: 'Americas', // 大洲
        checkCountry: [],
        countryId: ''
      },
      selectCountryArr: [], // 已选中的国家
      countryNameList: [], // 模糊查询相关国家列表
      indeterminate: true,
      checkAll: false,
      OzuList: [], // 大洲列表
      queryCountryType: [], // 大洲对应的国家列表
      pricingData: [],
      cachePricingData: [], // 缓存数据操作
      pricingModelColumns: [],
      pricingModelCommonColumns: [
        {
          title: self.t('common.startWeights'),
          key: 'startWeight',
          minWidth: 160,
          maxWidth: 240,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.startWeight ? params.row.startWeight : params.row.startWeight === 0 ? 0 : null,
                  min: 0,
                  disabled: params.index !== 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].startWeight = val;
                  }
                }
              })
            ]);
          }
        },
        {
          title: self.t('common.endWeights'),
          key: 'endWeight',
          minWidth: 160,
          maxWidth: 240,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.endWeight ? params.row.endWeight : params.row.endWeight === 0 ? 0 : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].endWeight = val;
                  }
                }
              })
            ]);
          }
        },
        {
          title: self.t('common.costPrice'),
          key: 'price',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.price ? params.row.price : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].price = val;
                  }
                }
              })
            ]);
          }
        },
        {
          title: self.t('common.registrationFee'),
          key: 'registrationFee',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber',
              {
                props: {
                  value: params.row.registrationFee ? params.row.registrationFee : params.row.registrationFee === 0 ? 0 : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].registrationFee = val;
                  }
                }
              }
            );
          }
        },
        {
          title: self.t('common.operatingCost'),
          key: 'operatingCost',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber',
              {
                props: {
                  value: params.row.operatingCost ? params.row.operatingCost : params.row.operatingCost === 0 ? 0 : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].operatingCost = val;
                  }
                }
              }
            );
          }
        },
        {
          title: self.t('common.additionalFeeRate'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber',
              {
                props: {
                  value: params.row.additionalFeeRate ? params.row.additionalFeeRate : params.row.additionalFeeRate === 0 ? 0 : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].additionalFeeRate = val;
                  }
                }
              }
            );
          }
        }
      ],
      pricingModelContinuedHeavyColumns: [
        {
          title: self.t('common.firstWeight'),
          key: 'firstWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.firstWeight ? params.row.firstWeight : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].firstWeight = val;
                  }
                }
              })
            ]);
          }
        },
        {
          title: self.t('common.firstWeightPrice'),
          key: 'firstWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.firstWeightPrice ? params.row.firstWeightPrice : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].firstWeightPrice = val;
                  }
                }
              })
            ]);
          }
        },
        {
          title: self.t('common.unitWeight'),
          key: 'unitWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.unitWeight ? params.row.unitWeight : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].unitWeight = val;
                  }
                }
              })
            ]);
          }
        },
        {
          title: self.t('common.unitWeightPrice'),
          key: 'unitWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.unitWeightPrice ? params.row.unitWeightPrice : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].unitWeightPrice = val;
                  }
                }
              })
            ]);
          }
        }
      ],
      fixedPriceColumns: [
        {
          title: self.t('common.fixPrice'),
          key: 'price',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: 'red',
                  marginRight: '5px',
                  position: 'relative',
                  top: '5px'
                }
              }, '*'),
              h('InputNumber', {
                props: {
                  value: params.row.price ? params.row.price : null,
                  min: 0
                },
                style: {
                  width: '90%'
                },
                on: {
                  'input': (val) => {
                    self.cachePricingData[params.index].price = val;
                  }
                }
              })
            ]);
          }
        }
      ],
      cachePriceModelColumns: [],
      priceTypeStatus: null, // 存储表格数据的计费方式
      allCountryList: [] // 所有国家列表数据
    };
  },
  methods: {
    resetForm () {
      let v = this;
      v.cachePriceModelColumns = [];
      v.cachePricingData = [];
      v.pricingParams.checkCountry = [];
    },
    // 获取大洲和国家列表
    getQueryZoneList () {
      let v = this;
      let pos = [];
      v.axios.get(api.get_queryZoneCountry)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            let arr = [];
            data.forEach((n, o) => {
              arr.push({
                zoneCnName: n.zoneCnName,
                zoneCode: n.zoneCode,
                countries: n.countries
              });
            });
            pos.push(
              { zoneCnName: arr[0].zoneCnName, zoneCode: arr[0].zoneCode, countries: arr[0].countries, checked: true },
              { zoneCnName: arr[1].zoneCnName, zoneCode: arr[1].zoneCode, countries: arr[1].countries, checked: false },
              { zoneCnName: arr[2].zoneCnName, zoneCode: arr[2].zoneCode, countries: arr[2].countries, checked: false },
              { zoneCnName: arr[3].zoneCnName, zoneCode: arr[3].zoneCode, countries: arr[3].countries, checked: false },
              { zoneCnName: arr[4].zoneCnName, zoneCode: arr[4].zoneCode, countries: arr[4].countries, checked: false },
              { zoneCnName: arr[5].zoneCnName, zoneCode: arr[5].zoneCode, countries: arr[5].countries, checked: false },
              { zoneCnName: arr[6].zoneCnName, zoneCode: arr[6].zoneCode, countries: arr[6].countries, checked: false },
              { zoneCnName: arr[7].zoneCnName, zoneCode: arr[7].zoneCode, countries: arr[7].countries, checked: false },
              { zoneCnName: arr[8].zoneCnName, zoneCode: arr[8].zoneCode, countries: arr[8].countries, checked: false },
              { zoneCnName: arr[9].zoneCnName, zoneCode: arr[9].zoneCode, countries: arr[9].countries, checked: false }
            );
            v.OzuList = pos;
            arr.forEach((item, index) => {
              v.allCountryList.push(...item.countries);
            });
            // console.log(v.allCountryList);
            v.checkOzuTypeFn('Americas'); // 大洲
          }
        });
    },
    // 洲切换
    checkOzuTypeFn: function (value) {
      let v = this;
      v.OzuList.forEach(function (n) {
        n.checked = (n.zoneCode === value);
      });
      v.pricingParams.zoneCode = value;
      for (let i = 0; i < v.OzuList.length; i++) {
        if (v.pricingParams.zoneCode === v.OzuList[i].zoneCode) {
          v.refreshStatus = false;
          v.$nextTick(function () {
            v.refreshStatus = true;
          });
          v.queryCountryType = v.OzuList[i].countries;
        }
      }
    },
    // 全选
    handleCheckAll () {
      let v = this;
      let arr = [];
      if (v.indeterminate) {
        v.checkAll = false;
      } else {
        v.checkAll = !v.checkAll;
      }
      v.indeterminate = false;
      for (let i = 0; i < v.OzuList.length; i++) {
        if (v.pricingParams.zoneCode === v.OzuList[i].zoneCode) {
          v.queryCountryType.forEach((n, i) => {
            arr.push(n.countryId);
          });
          if (v.checkAll) {
            for (let j = 0; j < v.queryCountryType.length; j++) {
              if (v.getArriveCountryList.indexOf(v.queryCountryType[j].countryId) > -1) {
                v.$Message.warning({
                  content: v.t('error.countryAlreadyExist'),
                  duration: 5
                });
                return;
              }
            }
            v.pricingParams.checkCountry = arr;
          } else {
            v.pricingParams.checkCountry = [];
          }
        }
      }
    },
    // 勾选国家
    checkAllGroupChange (data) {
      let v = this;
      if (data.length === v.queryCountryType.length) {
        v.indeterminate = false;
        v.checkAll = true;
        v.pricingParams.checkCountry = data;
      } else if (data.length > 0) {
        v.indeterminate = true;
        v.checkAll = false;
        v.pricingParams.checkCountry = data;
      } else {
        v.indeterminate = false;
        v.checkAll = false;
        v.pricingParams.checkCountry = data;
      }
    },
    // 搜索词改变时触发
    queryChange (query) {
      let v = this;
      // var isChinese = new RegExp("[\u4E00-\u9FA5]+"); //验证是否是中文
      var isEnglish = new RegExp('[A-Za-z]+'); // 验证是否是英文
      if (query !== '') {
        if (isEnglish.test(query) && query.length <= 1) {
          return false;
        }
        v.axios.get(api.get_queryCountryKeyword + '?keyword=' + query)
          .then(res => {
            if (res.data.code === 0) {
              v.countryNameList = res.data.datas;
            }
          });
      } else {
        v.countryNameList = [];
      }
    },
    // 中文，英文，二字码搜索
    selectCountryFn (val) {
      let v = this;
      for (let i = 0; i < v.countryNameList.length; i++) {
        if (val === v.countryNameList[i].countryId) {
          v.checkOzuTypeFn(v.countryNameList[i].zoneCode); // 大洲
          if (v.getArriveCountryList.indexOf(v.countryNameList[i].countryId) > -1) {
            v.$Message.warning({
              content: v.t('error.countryAlreadyExist'),
              duration: 5
            });
            return;
          }
          v.pricingParams.checkCountry.push(v.countryNameList[i].countryId); // 国家ID
        }
      }
    },
    // 获取计费模型表格数据
    getPrcingModelList () {
      let v = this;
      v.resetForm();
      v.axios.post(api.queryPriceZoneDtl2ver + '?shippingMethodId=' + v.shipId + '&priceModelZoneId=' + v.priceModelZoneId)
        .then(res => {
          if (res.data.code === 0) {
            let resData = res.data.datas;
            if (resData !== null) {
              v.setTableColumns(resData.priceType);
              v.priceTypeStatus = resData.priceType;
              v.pricingParams.priceType = resData.priceType;
              v.pricingParams.weightType = resData.weightType;
              v.pricingParams.volumeWeight = resData.volumeWeight;
              v.cachePricingData = resData.subList;
              let arr = resData.arriveCountryList;
              arr.forEach(n => {
                v.pricingParams.checkCountry.push(n.countryId);
              });
            } else {
              v.setTableColumns(v.pricingParams.priceType);
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 设置表格列
    setTableColumns (type) {
      let v = this;
      if (type === 1) {
        v.pricingModelColumns = v.pricingModelCommonColumns;
      } else if (type === 2) {
        v.getNewArr(v.pricingModelCommonColumns)
          .then(arr => {
            arr.splice(2, 1, ...v.pricingModelContinuedHeavyColumns);
            v.pricingModelColumns = arr;
          });
      } else {
        v.getNewArr(v.pricingModelCommonColumns)
          .then(arr => {
            arr.splice(2, 1, ...v.fixedPriceColumns);
            v.pricingModelColumns = arr;
          });
      }
    },
    // 浅拷贝数组
    getNewArr (arr) {
      let newArr = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          newArr.push(item);
          if (i === arr.length - 1) {
            resolve(newArr);
          }
        }
      });
    },
    // 把已选中的国家ID转国家名称
    getStateName (arr) {
      let v = this;
      if (arr.length === 0) return '';
      let arrName = [];
      let countryArr = [];
      for (let i = 0; i < v.allCountryList.length; i++) {
        let item = v.allCountryList[i];
        for (let t = 0; t < arr.length; t++) {
          let subItem = arr[t];
          if (subItem === item.countryId) {
            arrName.push(item.cnName);
            countryArr.push(item);
          }
          if (i === v.allCountryList.length - 1 && t === arr.length - 1) {
            v.selectCountryArr = countryArr;
            return arrName.toString();
          }
        }
      }
    },
    // 清空已选国家
    clearSelected () {
      let v = this;
      v.pricingParams.checkCountry = [];
      v.indeterminate = true;
      v.checkAll = false;
    },
    // 设置计费公式
    setPriceData () {
      let v = this;
      if (v.pricingParams.priceType === 1) {
        let formula = '运费' + '=' + '（' + '重量' + '*' + '单价' + '+' + '挂号费' + '+' + '操作费' + '）' + '*' + '（' + '1' + '+' + '附加费' + '）';
        return formula;
      } else if (v.pricingParams.priceType === 2) {
        let formula = '运费' + '=' + '{' + '首重费用' + '+' + '（' + '包裹重量' + '-' + '首重' + '）' + '/' + '续重单位重量' + '*' + '续重单价' + '+' + '挂号费' + '+' + '操作费' + '}' + '*' + '（' + '1' + '+' + '附加费' + '）';
        return formula;
      } else if (v.pricingParams.priceType === 3) {
        let formula = '运费' + '=' + '（' + '单价' + '+' + '挂号费' + '+' + '操作费' + '）' + '*' + '（' + '1' + '+' + '附加费' + '）';
        return formula;
      }
    },
    // 新增分区和保存计费模型公共校验
    createSubAreaValidFn () {
      let v = this;
      let valid = true;
      var reg = /^\d+$/;
      var regTwo = /^\d+(\.\d{1,5})?$/; // 只能保留五位小数
      if (v.cachePricingData.length > 0) {
        let item = v.cachePricingData[v.cachePricingData.length - 1];
        if (v.pricingParams.priceType === 1 || v.pricingParams.priceType === 3) {
          if (item.startWeight === null || item.startWeight === '') {
            v.$Message.error(v.t('error.startWeightNoEmpty'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.endWeight === null || item.endWeight === '') {
            v.$Message.error(v.t('error.endWeightNoEmpty'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.endWeight !== null && item.endWeight === 0) {
            v.$Message.error(v.t('error.endWeightNoZero'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (Number(item.endWeight) <= Number(item.startWeight)) {
            v.$Message.error(v.t('error.endNoLessOrEqualStart'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.price === null || item.price === '') {
            v.$Message.error(v.t('error.priceError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.price === 0) {
            v.$Message.error(v.t('error.priceError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!reg.test(item.startWeight) && item.startWeight !== '') {
            v.$Message.error(v.t('error.startWeightOnlyInteger'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!reg.test(item.endWeight) && item.endWeight !== '') {
            v.$Message.error(v.t('error.endWeightOnlyInteger'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.price) && item.price !== '') {
            v.$Message.error(v.t('error.pricesOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.registrationFee) && item.registrationFee !== '') {
            v.$Message.error(v.t('error.registrationFeeOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.operatingCost) && item.operatingCost !== '') {
            v.$Message.error(v.t('error.operatingFeeOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.additionalFeeRate) && item.additionalFeeRate !== '') {
            v.$Message.error(v.t('error.additionalFeeOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          }
          // for (let k = 0; k < v.cachePricingData.length; k++) {
          //   if (v.cachePricingData.length > 1 && v.cachePricingData.length > (k + 1) ) {
          //     if (Number(v.cachePricingData[k + 1].startWeight) <= Number(v.cachePricingData[k].endWeight)) {
          //       v.$Message.error(v.t('error.endMoreStartWeight'));
          //       v.$parent.pricingModal = true;
          //       valid = false;
          //       return;
          //     }
          //   }
          // }
        } else if (v.pricingParams.priceType === 2) {
          if (item.startWeight === null || item.startWeight === '') {
            v.$Message.error(v.t('error.startWeightNoEmpty'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.endWeight === null || item.endWeight === '') {
            v.$Message.error(v.t('error.endWeightNoEmpty'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.endWeight !== null && item.endWeight === 0) {
            v.$Message.error(v.t('error.endWeightNoZero'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (Number(item.endWeight) <= Number(item.startWeight)) {
            v.$Message.error(v.t('error.endNoLessOrEqualStart'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!reg.test(item.startWeight) && item.startWeight !== '') {
            v.$Message.error(v.t('error.startWeightOnlyInteger'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!reg.test(item.endWeight) && item.endWeight !== '') {
            v.$Message.error(v.t('error.endWeightOnlyInteger'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.firstWeight === null || item.firstWeight === '') {
            v.$Message.error(v.t('error.firstWeightError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.firstWeight !== null && item.firstWeight === 0) {
            v.$Message.error(v.t('error.firstWeightError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.firstWeightPrice === null || item.firstWeightPrice === '') {
            v.$Message.error(v.t('error.firstWeightPriceError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.firstWeightPrice !== null && item.firstWeightPrice === 0) {
            v.$Message.error(v.t('error.firstWeightPriceError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.firstWeightPrice) && item.firstWeightPrice !== '') {
            v.$Message.error(v.t('error.firstWeightPriceOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.unitWeight === null || item.unitWeight === '') {
            v.$Message.error(v.t('error.unitWeightError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.unitWeight !== null && item.unitWeight === 0) {
            v.$Message.error(v.t('error.unitWeightError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.unitWeightPrice === null || item.unitWeightPrice === '') {
            v.$Message.error(v.t('error.unitWeightPriceError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (item.unitWeightPrice !== null && item.unitWeightPrice === 0) {
            v.$Message.error(v.t('error.unitWeightPriceError'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.unitWeightPrice) && item.unitWeightPrice !== '') {
            v.$Message.error(v.t('error.unitWeightPriceOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.registrationFee) && item.registrationFee !== '') {
            v.$Message.error(v.t('error.registrationFeeOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.operatingCost) && item.operatingCost !== '') {
            v.$Message.error(v.t('error.operatingFeeOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          } else if (!regTwo.test(item.additionalFeeRate) && item.additionalFeeRate !== '') {
            v.$Message.error(v.t('error.additionalFeeOnlyFiveDecimals'));
            v.$parent.pricingModal = true;
            valid = false;
            return;
          }
          // for (let k = 0; k < v.cachePricingData.length; k++) {
          //  if (v.cachePricingData.length > 1 && v.cachePricingData.length > (k + 1) ) {
          //    if (Number(v.cachePricingData[k + 1].startWeight) <= Number(v.cachePricingData[k].endWeight)) {
          //      v.$Message.error(v.t('error.endMoreStartWeight'));
          //       v.$parent.pricingModal = true;
          //       valid = false;
          //       return;
          //     }
          //   }
          // }
        }
      }
      return valid;
    },
    // 保存数据
    savePricingData () {
      let v = this;
      let saveParamsObj = {
        arriveCountryList: v.selectCountryArr, // 通达国家
        priceModelId: v.priceModelId, // 模型ID
        priceModelZoneId: v.priceModelZoneId, // 分区ID
        priceType: v.pricingParams.priceType, // 计费方式
        subList: v.cachePricingData, // 分区表格数据
        volumeWeight: v.pricingParams.volumeWeight, // 材积重
        weightType: v.pricingParams.weightType, // 计重方式
        shippingMethodId: v.shipId, // 渠道管理渠道ID
        zoneName: '',
        formula: v.setPriceData() // 计费公式
      };
      if (!v.pricingParams.checkCountry.length) {
        v.$Message.error(v.t('error.nonCountry'));
        v.$parent.pricingModal = true;
        return;
      }
      if (!v.cachePricingData.length) {
        v.$Message.error(v.t('error.addWeightInterval'));
        v.$parent.pricingModal = true;
        return;
      }
      if (v.shipId === null) {
        if (v.isAddOrEdit === 'add') {
          if (v.createSubAreaValidFn()) {
            v.$emit('addPricesData', saveParamsObj);
            v.$Message.success(v.t('common.saveSuccess'));
          }
        } else if (v.isAddOrEdit === 'edit') {
          if (v.createSubAreaValidFn()) {
            saveParamsObj.clickIndex = this.clickIndex;
            v.$emit('sendData', saveParamsObj); // 新增的计费模型数据
            v.$Message.success(v.t('common.saveSuccess'));
          }
        }
      } else if (v.shipId !== null) {
        if (v.isAddOrEdit === 'add') {
          if (v.createSubAreaValidFn()) {
            v.axios.post(api.savePriceModel2ver, saveParamsObj)
              .then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(v.t('common.saveSuccess'));
                  v.$parent.pricingModal = false; // 关闭计费模型模态框
                  v.$emit('closeModal', saveParamsObj);
                  v.cachePricingData = [];
                } else {
                  v.$Message.error(v.t('common.saveFailed'));
                  v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
                }
              });
          }
        } else if (v.isAddOrEdit === 'edit') {
          if (v.createSubAreaValidFn()) {
            v.axios.post(api.updatePriceModeZone2ver, saveParamsObj)
              .then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(v.t('common.saveSuccess'));
                  v.$parent.pricingModal = false; // 关闭计费模型模态框
                  v.$emit('closeModal', saveParamsObj);
                  v.cachePricingData = [];
                } else {
                  v.$Message.error(v.t('common.saveFailed'));
                  v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
                }
              });
          }
        }
      }
    },
    // 新增重量区间
    addSubArea () {
      let v = this;
      if (v.createSubAreaValidFn()) {
        let obj = {
          startWeight: 0,
          endWeight: null,
          price: null,
          firstWeight: null,
          firstWeightPrice: null,
          unitWeight: null,
          unitWeightPrice: null,
          registrationFee: 0,
          operatingCost: 0,
          additionalFeeRate: 0,
          sortNo: 1
        };
        v.cachePricingData.push(obj);
        for (let k = 0; k < v.cachePricingData.length; k++) {
          if (v.cachePricingData[k].endWeight) {
            v.cachePricingData[k + 1].startWeight = v.cachePricingData[k].endWeight;
          }
        }
      }
    },
    initDataFn () {
      let v = this;
      v.pricingParams.priceType = 1;
      v.pricingParams.weightType = 1;
      v.pricingParams.volumeWeight = 0;
      v.pricingParams.zoneCode = 'Americas';
      v.pricingParams.countryId = '';
      v.countryNameList = [];
      v.indeterminate = true;
      v.checkAll = false;
      v.pricingParams.checkCountry = [];
    },
    // 编辑当前行的计费模型数据
    curSingleDataFn () {
      let v = this;
      v.pricingParams.priceType = v.curSingleDtl.priceType; // 计费方式
      v.pricingParams.weightType = v.curSingleDtl.weightType; // 计重方式
      v.pricingParams.volumeWeight = v.curSingleDtl.volumeWeight; // 材积重
      v.cachePricingData = v.curSingleDtl.subList; // 表格数据
      let arr = v.curSingleDtl.arriveCountryList; // 当前行选择的国家
      if (arr) {
        arr.forEach((n, o) => {
          v.pricingParams.checkCountry.push(n.countryId);
        });
      }
    },
    // 已选国家禁选
    checkdisplayAble (countryId) {
      let v = this;
      let checkCountryArrs = '';
      if (v.curSingleDtl.arriveCountryList && !v.isAdd) {
        v.curSingleDtl.arriveCountryList.forEach((item, index) => {
          if (checkCountryArrs !== '') {
            checkCountryArrs += ',';
          }
          checkCountryArrs += item.countryId;
        });
      }
      let isFound = false;
      if (v.getArriveCountryList.indexOf(countryId) > -1) {
        isFound = true;
      }
      if (isFound) {
        if (checkCountryArrs === '' || checkCountryArrs.indexOf(countryId) === -1) {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  created () {
    this.getQueryZoneList(); // 大洲和国家列表
  },
  watch: {
    'pricingParams.priceType': {
      handler (n, o) {
        let v = this;
        if (n !== o) {
          v.setTableColumns(n);
          if (n !== v.priceTypeStatus) { // 切换其他模板，清空数据
            v.cachePricingData = [];
          } else {
            v.getPrcingModelList();
          }
        }
      }
    },
    isAddOrEdit: function (val) {
      let v = this;
      if (v.shipId !== null && val === 'edit') { // 编辑计费模型里面的编辑
        v.isAdd = false;
        v.getPrcingModelList();
      } else if (v.shipId !== null && val === 'add') { // 编辑计费模型里面的新增
        v.isAdd = true;
        v.setTableColumns(1);
        v.cachePricingData = [];
        v.initDataFn();
      } else if (v.shipId === null && val === 'add') { // 新增计费模型里面的新增
        v.isAdd = true;
        v.setTableColumns(1);
        v.cachePricingData = [];
        v.initDataFn();
      } else if (v.shipId === null && val === 'edit') { // 新增计费模型里面的编辑
        v.isAdd = false;
        v.setTableColumns(v.pricingParams.priceType);
        v.curSingleDataFn();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/pricingModel.vue